export enum PreviewSize {
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
}
